/* Modules are returned from this helper function, it returns any module with type and data that it's passed on */
import React from "react";
import Module from "components/modules";

const RenderModules = ({ modules }) => {
    if (!modules) return null;

    return modules?.map((module) => (
        <Module
            key={module._key}
            type={module._type}
            moduleData={module}
        />
    ));
};

export default RenderModules;
